import {Platform, StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    flex: 1,
    backgroundColor: white,
    paddingHorizontal: 5,
    marginTop: 15,
  },

  scrollViewBase: {
    flex: 1,
  },

  headerText: {
    width: '100%',
    fontSize: 16,
    fontWeight: '500',
    marginLeft: indent * 0.5,
  },

  goBackIcon: {
    marginLeft: -10,
  },

  content: {
    paddingHorizontal: 16,
    paddingBottom: 50,
    flexGrow: 1,
  },

  instructionContainer: {
    marginBottom: 20,
  },

  instructionHeader: {
    fontSize: 14,
    fontWeight: '700',
    marginBottom: 10,
    color: '#111827',
  },

  instructionText: {
    fontFamily: 'OpenSans',
    fontSize: 12,
    color: '#383838',
    lineHeight: 25,
  },

  fieldRow: {
    marginBottom: 18,
  },

  fieldLabel: {
    fontSize: 16,
    fontWeight: '600',
    color: '#414651',
    marginBottom: 8,
  },

  baseUrlText: {
    fontSize: 12,
    color: '#6B7280',
  },

  inputRow: {
    flexDirection: 'row',
    alignItems: 'stretch',
    minHeight: 58,
    borderWidth: 1,
    borderColor: '#E0E0E0',
    borderRadius: 8,
    backgroundColor: 'white',
  },

  inputContainer: {
    flex: 1,
    minWidth: 0,
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },

  textInput: {
    flex: 1,
    fontSize: 14,
    color: '#1C1C1E',
    paddingHorizontal: 12,
    paddingVertical: Platform.OS === 'ios' ? 12 : 8,
    textAlignVertical: 'center',
    includeFontPadding: true,
  },

  baseUrlContainer: {
    justifyContent: 'center',
    paddingHorizontal: 10,
    borderRightWidth: 1,
    borderRightColor: '#C4C7CC',
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
  },

  customPlaceholder: {
    color: '#9CA3AF',
  },

  textInputFocusable: {
    width: '100%',
  },

  inputRowDisabled: {
    opacity: 0.6,
  },

  inputRowError: {
    borderColor: '#D9534F',
  },

  fieldError: {
    marginTop: 6,
    fontSize: 15,
    color: '#900B09',
  },

  containerOverlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'rgba(255, 255, 255, 0.4)',
    borderRadius: 8,
    zIndex: 10,
  },
});
